//import noUiSlider from "noUiSlider";

class SimpleDragRange {

    constructor(el) { 
        this.render(el)
    }

    
    render(el) {
        const { start = 0, rangeMin = 0, rangeMax } = el.dataset;

        var shadowValue = el.querySelectorAll('[data-shadow-value]')?.[0];

        //check that required deps are set.
        if (!shadowValue || !rangeMax) {
            console.error("the simple range is not configured correct", el);
            return;
        }
        var sliderEl = document.createElement('div');
        el.appendChild(sliderEl)

 
        
        noUiSlider.create(sliderEl, {
            start: [Number(start)],
            step: 1,
            behaviour: 'smooth-steps', //doesn't work - we are on an old version of the slider, and upgrade path has breaking changes I don't have time to investigate out.
            range: {
                'min': [Number(rangeMin)],
                'max': [Number(rangeMax)]
            },
            pips: { mode: 'steps', density: -1, filter: () => 2 } //always show a "size 2" step, with -1 density (disables each percent mark that is part of default pip behavior)
        });

        var pips = el.querySelectorAll('.noUi-value');

        function clickOnPip() {
            var value = Number(this.getAttribute('data-value'));
            sliderEl.noUiSlider.set(value);
        }

        //add a button to each pip so that it is clickable. 
        for (var i = 0; i < pips.length; i++) { 
            pips[i].style.cursor = 'pointer';
            const buttonElement = document.createElement('button');
            buttonElement.classList = "relative h-[1.125rem] w-[1.125rem] shrink-0 rounded-full bg-white transition-colors duration-300";
            pips[i].replaceChildren(buttonElement) 
            pips[i].addEventListener('click', clickOnPip);
        }


        //update shadow value and emit an input event to update alpine.
        sliderEl.noUiSlider.on('update', function (values, handle) { 
            shadowValue.value = Number(values[handle])
            shadowValue.dispatchEvent(new Event('input')) 
        });
    } 
}

document.querySelectorAll("[data-component='simple-drag-range']").forEach(x=> new SimpleDragRange(x))
class CarFinderRangeItem {
    constructor(el, index) {
        this.render(el, index);
    }

    onNavigation() {
        if(!this.touched){
            this.touched = true;
            this.updateGraph(this.start);
        }
    }

    handleUpdate(values) {
        this.updateGraph(values);
        this.updateLabels(values);
        this.updateImage(values);
    }

    handleStart(values){
        this.el.addClass('dragging');
    }

    handleEnd(values){
        this.el.removeClass('dragging');
    }

    handleChange(values){
        this.touched = true;
        this.input.val(values);
    }

    updateLabels(values){
        if(this.labels){
            $.each(this.labels, (index, label) => {
                if(index === values[0]){
                    $(label).css('display', 'block');
                }else{
                    $(label).css('display', 'none');
                }
            });
        }
    }

    updateImage(values){
        if(this.images){
            $.each(this.images, (index, image) => {
                if(index === values[0]){
                    $(image).css('display', 'block');
                }else{
                    $(image).css('display', 'none');
                }
            });
        }
    }

    updateGraph(values) {
        //console.log(' **********************   touch: ' + this.touched + ', values: ' + values);
        //console.log('graph.length= ' + this.graph.length + ', graphInner.length= ' + this.graphInner.length + ', graphInnerBackground.length= ' + this.graphInnerBackground.length);

        if(this.graph.length > 0 
            && this.graphInner.length > 0 
            && this.graphInnerBackground.length > 0
            && this.touched){
            const graphWidth = this.graph.width();
            const min = this.min[0];
            const max = this.max[0];
            const lower = values[0];
            const upper = values[1];
            const lowerPerc = (lower - min) / (max - min);
            const upperPerc = (upper - min) / (max - min);
            const rangePerc = upperPerc - lowerPerc;
            const left = Math.floor(graphWidth * lowerPerc);
            const right = graphWidth - Math.floor(graphWidth * upperPerc);

            this.graphInner.css('left', `${left}px`).css('right', `${right}px`);
            this.graphInnerBackground.css('left', `-${left}px`).css('right', `-${right}px`);
        }
    }

    render (el) {
        this.el = $(el);
        this.touched = false;

        this.events = {
            NAVIGATION_IN: 'NAVIGATION_IN'
        };

        this.action = 'CAR_FINDER_ANSWER';
        this.params = {
            question: this.el.attr('data-question'),
            answer: [],
        };

        this.sliders = this.el.find('*[data-component="c-car-finder-range-slider"]');
        this.images = this.el.find('*[data-component="c-car-finder-range-image"]');
        this.labels = this.el.find('*[data-component="c-car-finder-range-label"]');
        this.graphs = this.el.find('*[data-component="c-car-finder-range-graph"]');
        this.graphsInner = this.el.find('*[data-component="c-car-finder-range-graph-inner"]');
        this.graphsInnerBackground = this.el.find('*[data-component="c-car-finder-range-graph-inner-background"]');
        this.inputs = this.el.find('*[data-component="c-car-finder-range-input"]');
        this.graph = this.graphs ? $(this.graphs[0]) : null;
        this.graphInner = this.graphsInner ? $(this.graphsInner[0]) : null;
        this.graphInnerBackground = this.graphsInnerBackground ? $(this.graphsInnerBackground[0]) : null;
        this.input = this.inputs ? $(this.inputs[0]) : null;

        // get config from the component attributes
        this.min = this.el.data('range-min') ? this.el.data('range-min') : [1];
        this.max = this.el.data('range-max') ? this.el.data('range-max') : [5];
        this.start = this.el.data('range-start') ? this.el.data('range-start') : [0];
        const step = this.el.data('range-step') ? this.el.data('range-step') : 1;        
        const pips = this.el.data('range-pips');  
        const tooltips = this.el.data('range-tooltips');  

        let config = {
            start: this.start, 
            step, 
            range: {
                min: this.min, 
                max: this.max, 
            },
            tooltips,
            format: {
                to: function (value) {
                    return Math.floor(value);
                },
                from: function (value) {
                    return Number(value);
                }
            }
        };

        if(pips){
            config.pips = {
                mode: 'range',
                density: 100 / (this.max[0] - this.min[0])
            }
        }

        if(this.sliders.length > 0){
            this.slider = this.sliders[0];
            
            if(this.slider.noUiSlider){
                this.slider.noUiSlider.destroy();
            }
    
            noUiSlider.create(this.slider, config);
     
            this.slider.noUiSlider.on('start', this.handleStart.bind(this));
            this.slider.noUiSlider.on('end', this.handleEnd.bind(this));
            this.slider.noUiSlider.on('update', this.handleUpdate.bind(this));
            this.slider.noUiSlider.on('change', this.handleChange.bind(this));
        }        

        // handle events from other components
        this.el.on(this.events.NAVIGATION_IN, this.onNavigation.bind(this));

        // set defaults
        this.input.val(this.start);
        
    }
}

class CarFinderRange {
    constructor(selector) {
        this.selector = selector;
        $(window).on('RESET_COMPONENTS', this.start.bind(this));
        this.start();
    }

    start() {
        this.all = document.querySelectorAll(this.selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }

    render (el, index) {
        new CarFinderRangeItem(el, index);
    }
}

export default CarFinderRange;
new CarFinderRange('*[data-component="c-car-finder-range"]');